module.exports = __webpack_public_path__ + "static/media/pete.4564f3c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pete.jpg
// module id = 722
// module chunks = 0